export const TEXTS_CONTRATACION = {
  es_ES: new Map([
    ['contratos_por_duracion_title', 'DURACIÓN DEL CONTRATO (MESES)'],
    ['months', 'meses'],
    ['contracts', 'contratos'],
    ['licitaciones_por_area_titulo', 'NÚMERO DE LICITACIONES POR ÁREA'],
    ['licitaciones_por_area', 'Licitaciones por área'],
    ['suma_por_area_title', 'IMPORTE (SIN IVA) POR ÁREA'],
    ['amount', 'Importe'],
    ['suma-tipo-contrato', 'IMPORTE (SIN IVA) POR TIPO'],
    ['total-amount', 'Suma de importe (Sin IVA).'],
    ['reset', 'Restablecer'],
    ['download', 'Descargar'],
    ['dataFrom', 'Datos del'],
    ['dataTo', 'al'],
    ['euros', '€'],
    ['anual_per_type', 'Importe sin IVA acumulado anual por tipo'],
    ['last_update', 'Última actualización: '],
    ['current_year', 'Año en curso: '],
  ]),
  ca_ES: new Map([
    ['contratos_por_duracion_title', 'DURACIÓ DEL CONTRACTE (MESOS)'],
    ['months', 'mesos'],
    ['contracts', 'contractes'],
    ['licitaciones_por_area_titulo', 'NOMBRE DE LICITACIONS PER ÀREA'],
    ['licitaciones_por_area', 'Licitacions per àrea'],
    ['suma_por_area_title', 'IMPORT (SENSE IVA) PER ÀREA'],
    ['amount', 'Import'],
    ['suma-tipo-contrato', 'IMPORT (SENSE IVA) PER TIPUS'],
    ['total-amount', "Suma d'import (Sense IVA)."],
    ['reset', 'Restablir'],
    ['download', 'Desar'],
    ['dataFrom', 'Dades del'],
    ['dataTo', 'al'],
    ['euros', '€'],
    ['anual_per_type', 'Import sense IVA acumulat anual per tipus'],
    ['last_update', 'Última actualització: '],
    ['current_year', 'Any en curs: '],
  ]),
};
